// weather.js — Fetches current temperature for SF 94110 from Open-Meteo.
// Free, no API key, CORS-friendly. Refreshes every 5 minutes.

export async function initWeather() {
  const el = document.getElementById("weather-temp");
  if (!el) return;

  // 94110 = Mission District, San Francisco
  const URL =
    "https://api.open-meteo.com/v1/forecast" +
    "?latitude=37.7483&longitude=-122.4153" +
    "&current=temperature_2m&temperature_unit=fahrenheit" +
    "&forecast_days=1";

  async function fetchTemp() {
    try {
      const res = await fetch(URL);
      if (!res.ok) return;
      const data = await res.json();
      const temp = data.current?.temperature_2m;
      if (temp != null) {
        el.textContent = `${temp.toFixed(1)}°F`;
      }
    } catch (_) {
      // No network or API down — leave as —
    }
  }

  fetchTemp();
  setInterval(fetchTemp, 300_000); // refresh every 5 min
}
